import useCtaButtonState from './useCtaButtonState';
import useIsAvailabilityDisabled from './useIsAvailabilityDisabled';
import useIsReservableVehicle from './useIsReservableVehicle';

export default function useIsNotAvailableForImmediatePurchase() {
  const { notifyMe } = useCtaButtonState();
  const isReservableVehicle = useIsReservableVehicle();
  const isAvailabilityDisabled = useIsAvailabilityDisabled();

  return Boolean(isAvailabilityDisabled || isReservableVehicle || notifyMe);
}
